import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/Auth/auth-service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {

       // Check if this is an authentication-related endpoint that should not trigger automatic logout
       const isAuthEndpoint = req.url.includes('/login') || 
       req.url.includes('/auth/get-otp') || 
       req.url.includes('/auth/verify-otp') || 
       req.url.includes('/auth/update-password') ||
       req.url.includes('/auth/agency-login') ||
       req.url.includes('/forgot-password') || 
       req.url.includes('/send-otp') || 
       req.url.includes('/verify-otp') || 
       req.url.includes('/reset-password');
    // Centralized error handling logic
      if (error.status === 401) {
        // Auto logout if 401 response returned from api
        // Only auto logout for 401 if it's not an authentication endpoint
        if (!isAuthEndpoint) {
          console.log('[ErrorInterceptor] Triggering force logout for 401');
          authService.forceLogout('Session expired (401 Unauthorized)');
        } else {
          console.log('[ErrorInterceptor] Skipping logout for auth endpoint 401');
        }
      }
      else if (error.status === 403) {
        // Only auto logout for 403 if it's not an authentication endpoint
        if (!isAuthEndpoint) {
          console.log('[ErrorInterceptor] Triggering force logout for 403');
          authService.forceLogout('Access forbidden (403 Forbidden)');
        } else {
          console.log('[ErrorInterceptor] Skipping logout for auth endpoint 403');
        }
      }
      else if (error.status === 404) {
        // Disable redirecting to error-screen for all 404 responses
        // Let components handle "no data" scenarios gracefully
        console.log('[ErrorInterceptor] 404 response - allowing component to handle gracefully');
      }
      else if (error.status === 500) {
        // Server error
        // alert('Internal server error. Please try again later.');
      } else {
        // Handle other errors
        const errorMessage = error.error?.message || error.message || 'An error occurred';
        // console.error('API Error:', errorMessage);
      }


      return throwError(() => error);
    })
  );
};
